import { render, staticRenderFns } from "./addShipmentForm.vue?vue&type=template&id=7241544c"
import script from "./addShipmentForm.vue?vue&type=script&lang=js"
export * from "./addShipmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports